export default __webpack_public_path__ + "static/viitorul-m-fbcce24b829d8bd9e8e39680db06d481.jpg";